import Date from '@/modules/AdminTools/components/Form/Date';

const EndDate = () => <Date name="plan_data.end_on" label="End On" required />;

export default EndDate;
